export default __webpack_public_path__ + "static/media/mayow_wyd3.eab2cdbf.jpg";